import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    CircularProgress,
    Paper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    FormControl,
    InputLabel,
    Select,
    Chip,
    MenuItem,
    FormHelperText
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as Yup from "yup";
import { KeyboardDatePicker } from '@material-ui/pickers';
import { BackButton } from '../../sc-utilities';
import QRCode from 'qrcode.react';
import moment from 'moment';
import '../../sc-product/qrCode.scss';
import {getDateFormat} from "../../sc-utilities/date";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: 'right'
    },
    qrCode: {
        float: 'left',
        marginRight: "0.5%",
    },
});

const ColliForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations, collies, warehouses, colliTypes, gradeIDs, productTypes, qrCode, ColliID, groups } = props;

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Formik
                enableReinitialize={false}
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, setFieldValue, handleChange, handleBlur, handleSubmit, isSubmitting } = formikProps;

                    const inputProps = {
                        autoComplete: 'new-password',
                        form: {
                            autoComplete: 'off',
                        },
                    }

                    return (
                        <form onSubmit={handleSubmit}>
                            {qrCode ? <span className="colli-tooltip">
                                <QRCode
                                    size={50}
                                    className={classes.qrCode}
                                    value={`<Colli>${ColliID}</Colli>`}
                                />
                                <span>
                                    <QRCode
                                        size={200}
                                        value={`<Colli>${ColliID}</Colli>`}
                                    />
                                </span>
                                <br /><br /><br />
                            </span>
                                : null}
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />
                            <TextField
                                name="Description"
                                value={values.Description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Description && touched.Description)}
                                placeholder={translations["description"] || "Description"}
                                label={translations["description"] || "Description"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["status"] || "Status"}</InputLabel>
                                <Select
                                    name="Status"
                                    value={values.Status}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Status && touched.Status)}
                                    placeholder={translations["status"] || "Status"}
                                    label={translations["status"] || "Status"}
                                    margin={"dense"}
                                    fullWidth={true}
                                >
                                    <MenuItem key={"Active"} value={"Active"}>
                                        {translations['active'] || 'Active'}
                                    </MenuItem>
                                    <MenuItem key={"Inactive"} value={"Inactive"}>
                                        {translations['inactive'] || 'Inactive'}
                                    </MenuItem>
                                </Select>
                            </FormControl>

                            <FormControl className={classes.formControl} disabled={props.disabled} margin="dense">
                                <Autocomplete
                                    name={'HolderColliID'}
                                    id="combo-box-demo"
                                    options={collies ? [...collies] : []}
                                    value={values.HolderColliID}
                                    onChange={(event, newValue) => {
                                        setFieldValue('HolderColliID', newValue);
                                    }}
                                    getOptionLabel={option => (typeof option.displayValue === 'string' ? option.displayValue : '')}
                                    renderInput={params => <TextField {...params} label={translations["location"] || "location"} margin="dense" fullWidth={true} />}
                                />
                            </FormControl>

                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["warehouse"] || "Warehouse"}</InputLabel>
                                <Select
                                    name="WarehouseID"
                                    label={translations["warehouse"] || "Warehouse"}
                                    margin={"dense"}
                                    value={values.WarehouseID || ''}
                                    onChange={handleChange}
                                    disabled={true}
                                >
                                    {
                                        (warehouses ? [...warehouses] : []).map(option => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.displayValue}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["colli_type"] || "Colli type"}</InputLabel>
                                <Select
                                    name="ColliTypeID"
                                    label={translations["colli_type"] || "Colli type"}
                                    margin={"dense"}
                                    value={values.ColliTypeID}
                                    onChange={handleChange}
                                    disabled={true}
                                >
                                    {(colliTypes ? [...colliTypes] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Autocomplete
                                name={'GradeIDs'}
                                multiple
                                id="GradeMultiSelect"
                                options={gradeIDs || []}
                                getOptionLabel={(option) => option.label}
                                filterSelectedOptions
                                value={values.GradeIDs}
                                onChange={(_, value) => setFieldValue('GradeIDs', value)}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" fullWidth={true} label={`${translations["allowed_grades"] || "Allowed grades (not selected means all allowed)"}`} />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                            />
                            <Autocomplete
                                name={'AllowedProductTypeIDs'}
                                multiple
                                id="AllowedProductMultiSelect"
                                options={productTypes || []}
                                getOptionLabel={(option) => option.label}
                                filterSelectedOptions
                                value={values.AllowedProductTypeIDs}
                                onChange={(_, value) => setFieldValue('AllowedProductTypeIDs', value)}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" fullWidth={true} label={`${translations["allowed_product_type_not"] || "Allowed product types (not selected means all allowed)"}`} />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                            />
                            <FormHelperText>{translations['arrived_at'] || 'Arrived at'}</FormHelperText>
                            <KeyboardDatePicker
                                clearable
                                name={'ArrivedAt'}
                                onBlur={handleBlur}
                                maxDate={moment()}
                                error={!!(errors.ArrivedAt && touched.ArrivedAt)}
                                onChange={(date) => {
                                    setFieldValue("ArrivedAt", date);
                                    setFieldValue("DateEnd", '');
                                    setFieldValue("DateStarted", '');
                                    setFieldValue("Finished", '');
                                }}
                                value={values.ArrivedAt !== "" ? values.ArrivedAt : null}
                                margin={"dense"}
                                onAccept={date => setFieldValue("ArrivedAt", date)}
                                fullWidth={true}
                                format={getDateFormat()}
                            />
                            <FormHelperText>{translations['date_started'] || 'Date Started'}</FormHelperText>
                            <KeyboardDatePicker
                                clearable
                                name={'DateStarted'}
                                allowKeyboardControl={false}
                                disabled={!values.ArrivedAt}
                                minDate={values.ArrivedAt}
                                onBlur={handleBlur}
                                disableFuture
                                error={!!(errors.DateStarted && touched.DateStarted)}
                                onChange={(date) =>
                                    setFieldValue("DateStarted", date)
                                }
                                value={values.DateStarted !== "" ? values.DateStarted : null}
                                margin={"dense"}
                                onAccept={date => setFieldValue("DateStarted", date)}
                                fullWidth={true}
                                format={getDateFormat()}
                            />
                            <FormHelperText>{translations['finished'] || 'Finished'}</FormHelperText>
                            <KeyboardDatePicker
                                clearable
                                name={'Finished'}
                                disabled={!values.DateStarted}
                                minDate={values.DateStarted}
                                onBlur={handleBlur}
                                disableFuture
                                error={!!(errors.Finished && touched.Finished)}
                                onChange={(date) =>
                                    setFieldValue("Finished", date)
                                }
                                value={values.Finished !== "" ? values.Finished : null}
                                margin={"dense"}
                                onAccept={date => setFieldValue("Finished", date)}
                                fullWidth={true}
                                format={getDateFormat()}
                            />
                            <FormHelperText>{translations['date_end'] || 'Date End'}</FormHelperText>
                            <KeyboardDatePicker
                                clearable
                                name={'DateEnd'}
                                onBlur={handleBlur}
                                error={!!(errors.DateEnd && touched.DateEnd)}
                                minDate={values.Finished}
                                disabled={!values.Finished}
                                onChange={(date) =>
                                    setFieldValue("DateEnd", date)
                                }
                                value={values.DateEnd !== "" ? values.DateEnd : null}
                                margin={"dense"}
                                onAccept={date => setFieldValue("DateEnd", date)}
                                fullWidth={true}
                                format={getDateFormat()}
                            />
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            id="checkbox_locked"
                                            name={"Locked"}
                                            checked={values.Locked}
                                            onChange={handleChange}
                                            color={'primary'}
                                        />
                                    }
                                    label={translations["locked"] || "Locked"}
                                />
                            </FormGroup>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["locked_reason"] || "Locked reason"}</InputLabel>
                                <Select
                                    name="LockedType"
                                    value={values.LockedType}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.LockedType && touched.LockedType)}
                                    placeholder={translations["locked_reason"] || "Locked reason"}
                                    label={translations["locked_reason"] || "Locked reason"}
                                    margin={"dense"}
                                    fullWidth={true}
                                >
                                    <MenuItem key={"not_for_sale"} value={"Not for sale & content may not be changed"}>
                                        {translations['not_for_sale'] || 'Not for sale & content may not be changed'}
                                    </MenuItem>
                                    <MenuItem key={"no_products_may_be_added"} value={"No products may be added"}>
                                        {translations['no_products_may_be_added'] || 'No products may be added'}
                                    </MenuItem>
                                    <MenuItem key={"no_products_may_be_removed"} value={"No products may be removed"}>
                                        {translations['no_products_may_be_removed'] || 'No products may be removed'}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["group"] || "Group"}</InputLabel>
                                <Select
                                    name="GroupID"
                                    label={translations["group"] || "Group"}
                                    margin={"dense"}
                                    value={values.GroupID}
                                    onChange={handleChange}
                                >
                                    {(groups ? [...groups] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <div className={classes.buttons}>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(ColliForm);
